module.exports = __webpack_public_path__ + "static/img/computer_s.bbe4c6bd.png";